import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    fetch(`${BACKEND_URL}/api/auth/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((r) => {
        if (!r.ok) throw new Error("session exchange failed");
        return r.json();
      })
      .then((user) => navigate("/", { replace: true, state: { user } }))
      .catch(() => navigate("/", { replace: true }));
  }, [location, navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="flex min-h-screen items-center justify-center bg-[#0B0C0E]"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#FF9900]/20 border-t-[#FF9900]" />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Signing you in…</p>
      </div>
    </div>
  );
};
